import { ComponentPropsWithoutRef } from 'react';
import { Box, useTheme } from '@mui/material';
import { isRevampDashboardTheme } from 'src/utils/revampThemeBoundary';

/**
 * Preserve semantic tables and all cell content. Rollout tables need a readable
 * minimum width: long source IDs must not squeeze headers into single letters.
 * Overflow is local and keyboard-scrollable; legacy themes keep native markup.
 */
export default function MarkdownTable({
  children,
  ...props
}: ComponentPropsWithoutRef<'table'>) {
  const theme = useTheme();

  if (!isRevampDashboardTheme(theme)) {
    return <table {...props}>{children}</table>;
  }

  return (
    <Box sx={{ maxWidth: '100%', overflowX: 'auto', mb: 2 }} tabIndex={0}>
      <Box
        component="table"
        {...props}
        sx={{
          width: '100%',
          minWidth: 480,
          borderCollapse: 'collapse',
          '& th, & td': {
            px: 1.5,
            py: 1,
            verticalAlign: 'top',
            textAlign: 'start',
            borderBottom: 1,
            borderColor: 'divider',
            wordBreak: 'normal',
          },
          '& th': { whiteSpace: 'nowrap' },
          '& td': { minWidth: 80, maxWidth: 480, overflowWrap: 'anywhere' },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
